import { DSDeal } from 'shared-definitions/types'
import { nullableString } from 'shared-code/conversion'
import { ApiDealProps } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { pLinkExternalMapper, pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function oneDealMapper(input: ApiDealProps, opts: PLinkMapperOpts): Omit<DSDeal, 'price'> {
  return {
    title: input.title,
    pLink: pLinkMapper(input.url, opts),
    pLinkEdit: input.edit_url ? pLinkExternalMapper(input.edit_url) : null,
    added: input.added,
    buttonText: 'Get Deal',
    image: input.image ? imageMapper({ src: input.image }, opts) : null,
    score: null,
    store: nullableString(input.store),
  }
}
